import React from 'react';
import { TrendingDown, Activity, TrendingUp, Check } from 'lucide-react';

export default function ScenarioCard({
  title,
  scenarioKey,
  roiPct,
  paybackMonths,
  multiplier,
  selected,
  onSelect,
  isCustom = false
}) {
  const getIcon = () => {
    switch (scenarioKey) {
      case 'conservative':
        return TrendingDown;
      case 'aggressive':
        return TrendingUp;
      default:
        return Activity;
    }
  };
  
  // Use Adaptive Blue (#18365E) for active state, Interactive Orange (#FF6E4C) for custom
  const getColors = () => {
    if (selected) {
      return {
        bg: 'bg-white',
        border: 'border-[#18365E] border-[3px]',
        shadow: 'shadow-lg shadow-[#18365E]/20',
        icon: 'text-[#18365E]',
        multiplier: 'text-[#18365E]'
      };
    }
    return {
      bg: 'bg-white',
      border: 'border-gray-200',
      shadow: '',
      icon: 'text-gray-600',
      multiplier: 'text-gray-600'
    };
  };
  
  const Icon = getIcon();
  const colors = getColors();
  
  return (
    <button
      onClick={onSelect}
      className={`
        relative p-6 rounded-xl border transition-all duration-200 cursor-pointer
        hover:shadow-lg hover:-translate-y-1 hover:scale-[1.02] ${colors.bg} ${colors.border} ${colors.shadow}
        ${selected ? 'ring-2 ring-[#18365E]/30 shadow-xl' : ''}
      `}
      title={selected ? 'Active scenario' : 'Click to select scenario'}
    >
      {/* Iteration 6: Active tag */}
      {selected && (
        <div className="absolute top-3 right-3 z-10">
          <div className="bg-[#18365E] text-white text-[10px] font-semibold px-2 py-1 rounded-full shadow-md">
            Active
          </div>
        </div>
      )}
      
      {/* Iteration 6: Inner glow for active state */}
      {selected && (
        <div className="absolute inset-0 rounded-xl border-2 border-[#18365E]/20 pointer-events-none"></div>
      )}
      
      {/* Iteration 6: Custom scenario orange glow */}
      {isCustom && (
        <div className="absolute inset-0 rounded-xl ring-1 ring-[#FF6E4C]/30 pointer-events-none"></div>
      )}
      
      <div className="flex items-center justify-between mb-3">
        <div className="flex-1">
          <h3 className="font-semibold text-gray-900 text-base mb-1">{title}</h3>
          <div className="text-xs text-gray-500">
            {isCustom ? (
              <span 
                className="inline-flex items-center px-2 py-0.5 rounded-full bg-[#FF6E4C]/10 text-[#FF6E4C] font-medium ring-1 ring-[#FF6E4C]/20"
                title="Contains modified assumptions"
              >
                User Modified
              </span>
            ) : (
              <span className="text-gray-500">Standard Model</span>
            )}
          </div>
        </div>
        <Icon className={`w-5 h-5 ${colors.icon} flex-shrink-0 ml-2`} />
      </div>
      
      <div className="space-y-3">
        <div>
          <div className="text-3xl font-bold text-gray-900">
            {Math.round(roiPct)}%
          </div>
          <div className="text-xs text-gray-600">ROI</div>
        </div>
        
        <div>
          <div className="text-xl font-semibold text-gray-900">
            {paybackMonths ? `${paybackMonths} mo` : 'No payback'}
          </div>
          <div className="text-xs text-gray-600">Payback period</div>
        </div>
        
        <div className={`text-sm font-medium ${colors.multiplier}`}>
          {multiplier}× multiplier
        </div>
      </div>
    </button>
  );
}